import "./deepdive-pie.scss";
import ReactECharts from "echarts-for-react";
import moment, { Moment } from "moment";
import { useState, useEffect, useCallback } from "react";
import { AlphaValues, DeepDiveType } from "types";

function DeepDivePie({
  rail,
  breakDownPeriod,
  dateTo,
  vals,
  diveData,
}: {
  rail: string;
  breakDownPeriod: string;
  dateTo: Moment;
  vals: any[];
  diveData: DeepDiveType[];
}) {
  var sorted = diveData.filter(x => vals.includes(x.Value));
  var sortedData: any[] = GetSortedData(breakDownPeriod, sorted);
  var brandDescriptions = ["Owned", "Earned", "Chatter"];
  var innerLegend = [];
  var pieData: any[] = [];
  var innerPieData: any[] = [];
  innerLegend.push("Owned", "Earned", "Chatter");
  const [legend, setLegend] = useState<any[]>(vals);
  const [objectPieData, setObjectPieData] = useState<object>(pieData);
  const [objectInnerPieData, setObjectInnerPieData] = useState<object>(innerPieData);
 
  function GetSortedData(breakDownPeriod: string, sorted: any[]) {
    var endDate: Date = new Date(dateTo.toDate());

    if (breakDownPeriod == "Hourly") {
      return (sortedData = sorted.filter(
        (x: DeepDiveType) =>
          new Date(x.DatePosted) >=
            new Date(
              new Date(endDate).setHours(
                new Date(endDate).getHours() - 12,
                0,
                0
              )
            ) &&
          moment(new Date(x.DatePosted).setHours(0, 0, 0, 0)).toDate() <=
            new Date(new Date(endDate).setHours(0, 0, 0, 0))
      ));
    } else if (breakDownPeriod == "Weekly") {
      return (sortedData = sorted.filter(
        (x) =>
          new Date(x.DatePosted) >=
            moment(
              new Date(
                new Date(endDate).setDate(new Date(endDate).getDate() - 7 * 5)
              ).setHours(0, 0, 0, 0)
            ).toDate() &&
          new Date(x.DatePosted) <=
            new Date(new Date(endDate).setHours(0, 0, 0, 0))
      ));
    } else {
      return (sortedData = sorted.filter(
        (x) =>
          new Date(x.DatePosted) >=
            moment(
              new Date(
                new Date(endDate).setDate(new Date(endDate).getDate() - 7)
              ).setHours(0, 0, 0, 0)
            ).toDate() &&
          new Date(x.DatePosted) <=
            new Date(new Date(endDate).setHours(0, 0, 0, 0))
      ));
    }
  }

  function GetBrandAssociationTotal(
    item: any,
    sortedData: any[],
    brandAssociationDescription: string
  ) {
    if (brandAssociationDescription == "Owned") {
      var data = sortedData.filter(
        (x: any) => x.Value == item && x.BrandAssociationId == 1
      ).length;
    } else if (brandAssociationDescription == "Earned") {
      var data = sortedData.filter(
        (x: any) => x.Value == item && x.BrandAssociationId == 2
      ).length;
    } else {
      var data = sortedData.filter(
        (x: any) =>
          x.Value == item &&
          (x.BrandAssociationId == 3 || x.BrandAssociationId == 0)
      ).length;
    }
    return data;
  }

  function GetInnerPieData(item: any, sortedData: any[]) {
    var brandTotal = 0;
    for (var data of sortedData) {
      if (item == "Owned") {
        brandTotal += data.owned;
      } else if (item == "Earned") {
        brandTotal += data.earned;
      } else {
        brandTotal += data.chatter;
      }
    }
    return brandTotal;
  }

  function GetInnerPieColor(item: any) {
    if (item == "Owned") {
      return "#639FE3";
    } else if (item == "Earned") {
      return "#4BB543";
    } else {
      return "#FF6821";
    }
  }

  const setPieData = useCallback(() => {
    pieData = [];
   console.log("In setPieData");
    for (var item of vals) {
      pieData.push({
        name: item,
        value: sortedData.filter((x) => x.Value == item).length,
        owned: GetBrandAssociationTotal(item, sortedData, "Owned"),
        earned: GetBrandAssociationTotal(item, sortedData, "Earned"),
        chatter: GetBrandAssociationTotal(item, sortedData, "Chatter"),
      });
    }
    setObjectPieData(pieData);
  },[vals]);

 console.log("Legend", legend);

  const setInnerPieData = useCallback(() => {
    innerPieData = [];
    for (var item of brandDescriptions) {
      innerPieData.push({
        value: GetInnerPieData(item, pieData),
        name: item,
        itemStyle: { color: GetInnerPieColor(item)}
      });
    }
    setObjectInnerPieData(innerPieData);
  },[vals]);

  useEffect(() => {
    console.log("UseEffect Hit");
    setPieData();
    setInnerPieData();
  },[setPieData, setInnerPieData])


console.log("Pie Data", pieData);
  

  return (
    <>
      <div id="_DeepDivePieWidget">
        <div className="pie-heading">
          <p id="pie-heading">{rail} Comparison</p>
          <p id="date-period"></p>
        </div>
        <div
          id="deep-dive-pie-chart"
          className="deep-dive-pie-widget-container"
          style={{ height: "550px" }}
        >
          <ReactECharts
            option={{
              tooltip: {
                trigger: "item",
                formatter: "{a} <br/>{b}: {c} ({d}%",
              },
              legend: [
                {
                  data: vals,
                  margin: 15,
                  top: 8,
                  x: "center",
                },
                {
                  data: innerLegend,
                  margin: 15,
                  x: "right",
                  top: "25%",
                  orient: "vertical",
                },
              ],
              series: [
                {
                  name: "Content Classification",
                  type: "pie",
                  selectedMode: "single",
                  radius: ["0", "40%"],
                  center: ["50%", "55%"],
                  avoidLabelOverlap: false,
                  label: {
                    show: false,
                    position: "inner",
                  },
                  emphasis: {
                    label: {
                      show: true,
                      fontWeight: "bold",
                    },
                  },
                  labelLine: {
                    sow: false,
                  },
                  data: objectInnerPieData,
                },
                {
                  name: "Count Comparison",
                  type: "pie",
                  radius: ["60%", "80%"],
                  center: ["50%", "55%"],
                  avoidLabelOverlap: true,
                  label: {
                    formatter: function (params: any) {
                      return (
                        "Owned: " +
                        params.data.owned +
                        "\n" +
                        "Earned: " +
                        params.data.earned +
                        "\n" +
                        "Chatter: " +
                        params.data.chatter
                      );
                    },
                    fontSize: 11,
                    show: false,
                    position: "inner",
                  },
                  emphasis: {
                    label: {
                      show: true,
                      fontWeight: "bold",
                    },
                  },
                  labelLine: {
                    show: false,
                  },
                  data: objectPieData,
                },
              ],
            }}
            notMerge={true}
            lazyUpdate={false}
          />
         

        </div>
      </div>
    </>
  );
}

export default DeepDivePie;
